import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import App from '../components/App';

const WaitingComponent = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  );
};

export default (
  <Switch>
    <Route path='*'>
      <WaitingComponent />
    </Route>
  </Switch>
);
